export default __webpack_public_path__ + "static/media/jobs-table.37e64968.png";